import React from "react";
import SlaReportStaticRows from "./SlaReportStsticRows";
import SlaReportStaticRowsWithTime from "./SlaReportStaticRowsWithTime";
import {formatSlaReportMonthLabel} from "../slaReportUtils";

function SlaReportDetailEvidenceTable({ data, structure, month }) {
    const targetData = data.find(d => d.month === month) || data[0];
    const monthLabel = formatSlaReportMonthLabel(month);

    if (!targetData) return <div className="p-4 text-center text-gray-500">데이터 없음</div>;
    const getItem = (idx) => (targetData.item && targetData.item[idx]) ? targetData.item[idx] : {};

    // RowSpan 계산
    const availabilityRows = structure ? structure.length * 5 : 0;
    const errorManagementRows = 14;
    const managementServiceRowSpan = 38;

    return (
        <table className="w-full create-table table-border sla-report-detail-table" style={{tableLayout: "fixed"}}>
            <colgroup>
                <col style={{width: "15%"}} />
                <col style={{width: "18%"}} />
                <col style={{width: "18%"}} />
                <col style={{width: "18%"}} />
                <col style={{width: "31%"}} />
            </colgroup>
            <thead>
            <tr>
                <th className="fieldset-th-sla">서비스 구분</th>
                <th colSpan={2} className="fieldset-th-sla">측정지표</th>
                <th className="fieldset-th-sla">산출내역</th>
                <th className="fieldset-th-sla">{monthLabel}월 상세 데이터</th>
            </tr>
            </thead>
            <tbody>

            {/* [1. 가동률 섹션] - 장애관리와 함께 자동 배치 */}
            {structure && structure.map((codeInfo, index) => {
                const child = (targetData.children)
                    ? targetData.children.find(c => c.code && c.code.id === codeInfo.id) || {}
                    : {};

                return (
                    <React.Fragment key={index}>
                        <tr className="maintenance-section-group">
                            {index === 0 && <th className="fieldset-th-sla" rowSpan={availabilityRows}>유지보수 서비스</th>}
                            {index === 0 && <th className="fieldset-th-sla" rowSpan={availabilityRows}>가동률</th>}

                            <th className="fieldset-th-sla truncate" rowSpan={5}>{codeInfo.name}</th>
                            <th className="fieldset-th-sla">가중치</th>
                            <td className="fieldset-td-sla">{child.weight || 0} %</td>
                        </tr>
                        <tr className="maintenance-section-group">
                            <th className="fieldset-th-sla">운영시간</th>
                            <td className="fieldset-td-sla">{child.operationTimeKr || "-"}</td>
                        </tr>
                        <tr className="maintenance-section-group">
                            <th className="fieldset-th-sla">비계획된정지시간</th>
                            <td className="fieldset-td-sla">{child.stopTimeKr || "-"}</td>
                        </tr>
                        <tr className="maintenance-section-group">
                            <th className="fieldset-th-sla">평가점수</th>
                            <td className="fieldset-td-sla">{child.evaluationScore || 0} %</td>
                        </tr>
                        <tr className="maintenance-section-group">
                            <th className="fieldset-th-sla">환산점수</th>
                            <td className="fieldset-td-sla">{child.convertedScore || 0} %</td>
                        </tr>
                    </React.Fragment>
                );
            })}

            {/* [2. 장애관리 섹션] - 가동률과 함께 자동 배치 */}
            <tr className="error-management-start maintenance-section-group">
                <th className="fieldset-th-sla" rowSpan={errorManagementRows}>유지보수 서비스</th>
                <th className="fieldset-th-sla" rowSpan={errorManagementRows}>장애관리</th>

                <th className="fieldset-th-sla" rowSpan={5}>장애건수</th>
                <th className="fieldset-th-sla">가중치</th>
                <td className="fieldset-td-sla">{getItem(0).weight || 0} %</td>
            </tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">서비스장애</th><td className="fieldset-td-sla">{getItem(0).countOne || 0}</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">일반장애</th><td className="fieldset-td-sla">{getItem(0).countTwo || 0}</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">평가점수</th><td className="fieldset-td-sla">{getItem(0).evaluationScore || 0} %</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">환산점수</th><td className="fieldset-td-sla">{getItem(0).convertedScore || 0} %</td></tr>

            <tr className="maintenance-section-group">
                <th className="fieldset-th-sla" rowSpan={5}>장애 복구율</th>
                <th className="fieldset-th-sla">가중치</th>
                <td className="fieldset-td-sla">{getItem(1).weight || 0} %</td>
            </tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">장애건수</th><td className="fieldset-td-sla">{getItem(1).countOne || 0}</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">복구시간 초과건수</th><td className="fieldset-td-sla">{getItem(1).countTwo || 0}</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">평가점수</th><td className="fieldset-td-sla">{getItem(1).evaluationScore || 0} %</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">환산점수</th><td className="fieldset-td-sla">{getItem(1).convertedScore || 0} %</td></tr>

            <tr className="maintenance-section-group">
                <th className="fieldset-th-sla" rowSpan={4}>동일장애 발생건수</th>
                <th className="fieldset-th-sla">가중치</th>
                <td className="fieldset-td-sla">{getItem(2).weight || 0} %</td>
            </tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">동일장애건수</th><td className="fieldset-td-sla">{getItem(2).countOne || 0}</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">평가점수</th><td className="fieldset-td-sla">{getItem(2).evaluationScore || 0} %</td></tr>
            <tr className="maintenance-section-group"><th className="fieldset-th-sla">환산점수</th><td className="fieldset-td-sla">{getItem(2).convertedScore || 0} %</td></tr>


            {/* [3. 관리 서비스 섹션] - 항상 새 페이지 + 한 페이지에 모두 출력 */}
            <tr className="management-service-start management-service-section">
                <th className="fieldset-th-sla" rowSpan={managementServiceRowSpan}>관리 서비스</th>
            </tr>

            {/* 모든 관리 서비스 행에 클래스 추가 */}
            <SlaReportStaticRows title="보고" subTitle="적기보고 실시율" item={getItem(3)} labels={["장애 및 이슈 발생건수", "적기보고건수"]} keys={["countOne", "countTwo"]} className="management-service-section" />
            <SlaReportStaticRows title="관리" subTitle="각종 산출물 납기 일정 준수율" item={getItem(4)} labels={["전체 산출물 수", "산출물 제출일정 초과 건수"]} keys={["countOne", "countTwo"]} className="management-service-section" />

            <SlaReportStaticRowsWithTime title="서비스요청 적기처리율" item={getItem(5)} labels={["총 완료 서비스 요청건수", "적기에 완료한 서비스 요청건수", "총 지연시간"]} className="management-service-section" />
            <SlaReportStaticRowsWithTime title="작업 적기처리율" item={getItem(6)} labels={["총 완료 작업건수", "적기에 완료한 작업건수", "총 지연시간"]} className="management-service-section" />
            <SlaReportStaticRowsWithTime title="점검 적기처리율" item={getItem(7)} labels={["총 완료 점검건수", "적기에 완료한 점검건수", "총 지연시간"]} className="management-service-section" />

            <SlaReportStaticRows title="성능개선 제안" item={getItem(8)} rowSpan={4} labels={["성능개선 제안건수"]} keys={["countOne"]} className="management-service-section" />
            <SlaReportStaticRows title="내부자료 유출 및 중요 데이터 손실" item={getItem(9)} labels={["내부자료 유출횟수", "데이터 소실횟수"]} keys={["countOne", "countTwo"]} className="management-service-section" />

            {/* 합계 행 */}
            <tr className="management-service-section">
                <th className="fieldset-th-sla" colSpan={3}>합계</th>
                <th className="fieldset-th-sla">평가결과</th>
                <td className="fieldset-td-sla font-bold text-blue-600">
                    {targetData.evaluationResult ? targetData.evaluationResult + " %" : "0 %"}
                </td>
            </tr>
            </tbody>
        </table>
    );
}

export default SlaReportDetailEvidenceTable